import { fetcher } from "helpers/fetcher";

import { TUpdateStaffSettingReq, TUpdateStaffSettingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateStaffSetting = async (payload: TUpdateStaffSettingReq) => {
  return await fetcher<TUpdateStaffSettingRes, TUpdateStaffSettingReq["data"]>(
    ENDPOINT.USER.UPDATE_STAFF_SETTING,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.UPDATE_STAFF_SETTING.version,
        [API_HEADER.USER_ID]: payload.idUser,
      },
    }
  );
};

export const mutationUpdateStaffSetting = async (
  payload: TUpdateStaffSettingReq
) => {
  return (await updateStaffSetting(payload)).data;
};

mutationUpdateStaffSetting._key = (payload: TUpdateStaffSettingReq) => [
  ENDPOINT.USER.UPDATE_STAFF_SETTING.url,
  payload,
];
